/* Offcourt Club – Bedienung
   Ein gemeinsamer Hinweis-Kanal (immer nur ein Hinweis, nie während Match, Training oder Halle),
   Messung der Nutzung (Microsoft Clarity, Shopify-Kundenereignisse), Mitspieler-Vorschläge,
   „Nochmal“-Abkürzungen und einheitliche Begriffe. Läuft auf Club-Startseite und allen Tools. */
(function(){
  var TOOL = window.OC_TOOL_NAME || '';
  var MEMBER = !!window.OC_MEMBER;
  var mobile = window.matchMedia && matchMedia('(max-width: 899px)').matches;
  function get(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
  function set(k, v){ try { localStorage.setItem(k, v); } catch(e){} }
  function getJ(k){ try { return JSON.parse(get(k)); } catch(e){ return null; } }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  var app = function(){ return document.getElementById('oc-app'); };

  /* ---------------- Messung ---------------- */
  function track(name, props){
    props = props || {}; props.tool = props.tool || TOOL || 'club'; props.member = MEMBER;
    try { if (typeof window.clarity === 'function') window.clarity('event', 'oc_' + name); } catch(e){}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('oc_' + name, props); } catch(e){}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'oc_' + name, props); } catch(e){}
  }
  window.ocTrack = track;
  try { if (typeof window.clarity === 'function'){ window.clarity('set', 'oc_member', MEMBER ? 'ja' : 'nein'); window.clarity('set', 'oc_tool', TOOL || 'club'); } } catch(e){}
  track('open');

  /* ---------------- Hinweise: einer nach dem anderen, nach Wichtigkeit ---------------- */
  var Q = [], cur = null;
  function busy(){ return !!document.querySelector('#court:not([hidden]), #run:not([hidden]), #hall:not([hidden]), .ocs, .ocu-sheet:not([hidden]), .ocz-sheet'); }
  /* o = {id, prio, icon, title, text, actions:[{label, fn}], ttl, onClose}. Mit id wird ein Hinweis nur einmal gezeigt. */
  function toast(o){
    if (o.id && (get('ocu-seen-' + o.id) || (cur && cur.id === o.id) || Q.some(function(q){ return q.id === o.id; }))) return;
    Q.push(o); Q.sort(function(a, b){ return (b.prio || 0) - (a.prio || 0); }); pump();
  }
  function pump(){
    if (cur || !Q.length) return;
    if (busy()){ setTimeout(pump, 2500); return; }
    var o = cur = Q.shift();
    var el = document.createElement('div'); el.className = 'ocx-toast'; el.setAttribute('role', 'status');
    el.innerHTML = '<div class="i" aria-hidden="true">' + esc(o.icon || '') + '</div><div class="tx"><b>' + esc(o.title) + '</b><span>' + (o.html || esc(o.text || '')) + '</span></div><div class="a">' +
      (o.actions || []).map(function(a, i){ return '<button type="button" data-a="' + i + '">' + esc(a.label) + '</button>'; }).join('') + '<button type="button" class="x" aria-label="Schließen">✕</button></div>';
    document.body.appendChild(el);
    var tm = o.ttl === 0 ? null : setTimeout(function(){ close(false); }, o.ttl || 20000);
    function close(byUser){
      if (!el.parentNode) return;
      el.remove(); clearTimeout(tm); cur = null;
      if (o.id) set('ocu-seen-' + o.id, '1');
      if (byUser && o.onClose) o.onClose();
      setTimeout(pump, 400);
    }
    o.close = close;
    el.querySelector('.x').onclick = function(){ close(true); };
    [].forEach.call(el.querySelectorAll('[data-a]'), function(b){ b.onclick = function(){ var a = o.actions[+b.dataset.a]; close(false); track('hint_click', {hint: o.id || o.title}); a.fn(); }; });
  }
  window.ocToast = toast;
  window.ocToastClose = function(id){ if (cur && cur.id === id && cur.close) cur.close(false); Q = Q.filter(function(q){ return q.id !== id; }); };

  /* ---------------- Club als App: Hinweis über den gemeinsamen Kanal ---------------- */
  var deferred = null;
  window.addEventListener('beforeinstallprompt', function(e){ e.preventDefault(); deferred = e; });
  window.addEventListener('appinstalled', function(){ set('ocu-a2hs-off', '1'); window.ocToastClose('a2hs'); track('app_installed'); });
  function a2hs(){
    if (!mobile || TOOL === 'finder') return;
    var standalone = (window.matchMedia && matchMedia('(display-mode: standalone)').matches) || navigator.standalone;
    if (standalone){ set('ocu-a2hs-off', '1'); return; }
    if (get('ocu-a2hs-off')) return;
    var visits = (+get('ocu-visits') || 0) + 1; set('ocu-visits', String(visits));
    if (!MEMBER && visits < 2) return;
    setTimeout(function(){
      var ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
      toast({id: 'a2hs', prio: 1, icon: '📲', title: 'Club als App aufs Handy', ttl: 0,
        text: ios ? 'Unten auf „Teilen“ tippen, dann „Zum Home-Bildschirm“.' : deferred ? 'Dann öffnet sich der Club mit einem Tipp.' : 'Im Browser-Menü (⋮) „Zum Startbildschirm hinzufügen“ wählen.',
        actions: deferred ? [{label: 'Hinzufügen', fn: function(){ deferred.prompt(); }}] : [],
        onClose: function(){ set('ocu-a2hs-off', '1'); }});
    }, MEMBER ? 1500 : 4000);
  }

  /* ---------------- Mitspieler merken und vorschlagen ---------------- */
  var KP = 'oc-players-v1', SKIP = /^(wir|gegner|team \d|spieler \d+|ich)$/i;
  function players(){ var p = getJ(KP); return p && typeof p === 'object' ? p : {}; }
  function addNames(list){
    var p = players(), ch = false;
    list.forEach(function(n){ n = String(n || '').trim(); if (!n || n.length > 28 || SKIP.test(n)) return; p[n] = (p[n] || 0) + 1; ch = true; });
    if (!ch) return;
    var keep = Object.keys(p).sort(function(a, b){ return p[b] - p[a]; }).slice(0, 60), out = {};
    keep.forEach(function(k){ out[k] = p[k]; });
    set(KP, JSON.stringify(out)); fillList();
  }
  var prevSet = Storage.prototype.setItem;
  Storage.prototype.setItem = function(k, v){
    var watchK = k === 'oc-turnierplaner-v1' || k === 'oc-match-v1', old = null;
    if (watchK){ try { old = JSON.parse(this.getItem(k)); } catch(e){} }
    prevSet.apply(this, arguments);
    if (!watchK) return;
    var o = null; try { o = JSON.parse(v); } catch(e){}
    if (!o) return;
    if (k === 'oc-turnierplaner-v1' && !o.example && o.players && (!old || (old.players || []).join('|') !== o.players.join('|'))) addNames(o.players);
    if (k === 'oc-match-v1' && o.names){
      if (!old || !old.names || old.names.join('|') !== o.names.join('|')) addNames(o.names.join(' & ').split(/\s*(?:&|\/|,|\+| und )\s*/));
      set('ocu-last-teams', JSON.stringify(o.names));
    }
  };
  function fillList(){
    var dl = document.getElementById('ocu-players');
    if (!dl){ dl = document.createElement('datalist'); dl.id = 'ocu-players'; document.body.appendChild(dl); }
    var p = players(), me = String(getJ('oc-me-v1') || '').trim();
    var names = Object.keys(p).sort(function(a, b){ return p[b] - p[a]; });
    if (me && names.indexOf(me) < 0) names.unshift(me);
    dl.innerHTML = names.map(function(n){ return '<option value="' + esc(n) + '">'; }).join('');
  }

  /* ---------------- In den Tools: Begriffe, Vorschläge, „Nochmal“ ---------------- */
  function tools(){
    var a = app(); if (!a) return;
    /* Begriffe vereinheitlichen */
    var ts = a.querySelector('#tab-setup'); if (ts && ts.textContent !== 'Einrichten') ts.textContent = 'Einrichten';
    var sh = a.querySelector('#court #share'); if (sh && sh.textContent !== 'Ergebnis teilen') sh.textContent = 'Ergebnis teilen';
    /* Namensfelder mit Vorschlägen verbinden */
    [].forEach.call(a.querySelectorAll('#oc-main [data-pn], #ta, #tb'), function(i){ if (!i.getAttribute('list')) i.setAttribute('list', 'ocu-players'); });

    /* Match: letzte Teams übernehmen, Revanche */
    var last = getJ('ocu-last-teams');
    var ta = a.querySelector('#ta');
    if (ta && last && last.length === 2 && !a.querySelector('#ocuLast') && (ta.value !== last[0] || a.querySelector('#tb').value !== last[1])){
      var r = document.createElement('div'); r.className = 'ocu-quick'; r.id = 'ocuLast';
      r.innerHTML = '<span>Zuletzt: <b>' + esc(last[0]) + '</b> gegen <b>' + esc(last[1]) + '</b></span><button type="button" class="btn sm sec">Übernehmen</button>';
      var card = ta.closest('.card'); card.parentNode.insertBefore(r, card);
      r.querySelector('button').onclick = function(){ fillTeams(last); r.remove(); };
    }
    var nm = a.querySelector('#court #newM');
    if (nm && !a.querySelector('#ocuRev')){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'btn'; b.id = 'ocuRev'; b.textContent = 'Revanche';
      nm.insertAdjacentElement('beforebegin', b);
      b.onclick = function(){
        var t = getJ('oc-match-v1'); var names = t && t.names ? t.names.slice() : null;
        nm.click(); track('rematch');
        setTimeout(function(){ if (names && fillTeams(names)){ var go = a.querySelector('#go'); if (go) go.click(); } }, 60);
      };
    }

    /* Turnier: Spieler vom letzten Turnier übernehmen */
    var cr = a.querySelector('#create'), T = getJ('oc-turnierplaner-v1');
    if (cr && T && !T.example && T.players && !a.querySelector('#ocuSame')){
      var q = document.createElement('div'); q.className = 'ocu-quick'; q.id = 'ocuSame';
      q.innerHTML = '<span>Gleiche Runde wie „' + esc(T.name) + '“ (' + T.players.length + ' Spieler)?</span><button type="button" class="btn sm sec">Spieler übernehmen</button>';
      var first = a.querySelector('#oc-main .card'); if (first) first.parentNode.insertBefore(q, first);
      q.querySelector('button').onclick = function(){
        var n = a.querySelector('[data-n="' + T.players.length + '"]');
        if (n && n.getAttribute('aria-pressed') !== 'true') n.click();
        setTimeout(function(){
          T.players.forEach(function(p, i){ var inp = a.querySelector('#pn' + i); if (inp){ inp.value = p; inp.dispatchEvent(new Event('input', {bubbles: true})); } });
          var tn = a.querySelector('#tn'); if (tn){ tn.value = T.name; tn.dispatchEvent(new Event('input', {bubbles: true})); }
          track('repeat_tournament');
          var sq = a.querySelector('#ocuSame'); if (sq) sq.remove();
        }, 60);
      };
    }

    /* Turnierarchiv: mich selbst vorauswählen */
    var me = String(getJ('oc-me-v1') || '').trim().toLowerCase(), sel = a.querySelector('#archMe');
    if (me && sel && sel.value === '' && !sel.dataset.auto){
      sel.dataset.auto = '1';
      var opt = [].find.call(sel.options, function(o){ return o.textContent.trim().toLowerCase() === me; });
      if (opt){ sel.value = opt.value; sel.dispatchEvent(new Event('change', {bubbles: true})); }
    }
  }
  function fillTeams(names){
    var a = app(), ta = a && a.querySelector('#ta'), tb = a && a.querySelector('#tb');
    if (!ta || !tb) return false;
    ta.value = names[0]; ta.dispatchEvent(new Event('input', {bubbles: true}));
    tb.value = names[1]; tb.dispatchEvent(new Event('input', {bubbles: true}));
    return true;
  }

  function init(){
    fillList(); a2hs();
    var a = app(); if (!a) return;
    var b = false;
    new MutationObserver(function(){ if (b) return; b = true; try { tools(); } finally { b = false; } }).observe(a, {childList: true, subtree: true});
    tools();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();